
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"33","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.3 22.767H0L12.643 7.169l6.537 17L30.84.843l5.092 16.01L48.31 2.324 45.983 0h7.228v7.218L50.834 4.84 34.497 24.023l-4.388-13.78-11.35 22.706-7.009-18.937-7.45 8.755z"}})])
          )
        }
      }
    